export default __webpack_public_path__ + "assets/images/93d1cd9602f6bf8c806b59a259f1338b.svg";